import { render, staticRenderFns } from "./bannerListForm.vue?vue&type=template&id=0c58399b&scoped=true"
import script from "./bannerListForm.vue?vue&type=script&lang=js"
export * from "./bannerListForm.vue?vue&type=script&lang=js"
import style0 from "./bannerListForm.vue?vue&type=style&index=0&id=0c58399b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c58399b",
  null
  
)

export default component.exports